export enum WhoAreWeActionTypes {
    API_RESPONSE_SUCCESS = "@@whoAreWe/API_RESPONSE_SUCCESS",
    API_RESPONSE_ERROR = "@@whoAreWe/API_RESPONSE_ERROR",
  
    CREATE_WHO_ARE_WE_DATA = "@@whoAreWe/CREATE_WHO_ARE_WE_DATA",
    GET_WHO_ARE_WE_DATA = "@@whoAreWe/GET_WHO_ARE_WE_DATA",
    UPDATE_WHO_ARE_WE_DATA = "@@whoAreWe/UPDATE_WHO_ARE_WE_DATA",
    DELETE_WHO_ARE_WE_DATA = "@@whoAreWe/DELETE_WHO_ARE_WE_DATA",
  }